import Spinner from "components/Spinner";
import ShipCusContactAndBilling from "./ShipCusContactAndBilling";
import ShipCusCustomerDropDowns from "./ShipCusCustomerDropDowns";
import ShipCusCustomFields from "./ShipCusCustomFields";

export default function ShipCusAdvanceSearchForm({
  showModal,
  formData,
  setFormData,
  loading,
  handleSearch,
  saveRequest,
}) {
  /*   All Functions
   ********************************************* */
  const handleInputChange = (event, type) => {
    const { name, value } = event.target;
    // let updatedValue = type === "number" ? parseInt(value) : value;
    // setFormData({ ...formData, [name]: updatedValue });
    saveRequest(name, type === "number" ? parseInt(value) : value);
  };

  /*   All UseEffects
   ********************************************* */
  return (
    <div>
      {loading && <Spinner />}

      <div className="">
        <h4 className="border-bottom border-2 d-inline-block mb-1 pe-2">
          Contact & Billing
        </h4>
        <ShipCusContactAndBilling
          formData={formData}
          setFormData={setFormData}
          handleInputChange={handleInputChange}
        />

        <h4 className="border-bottom border-2 d-inline-block mb-1 pe-2 mt-3">
          General Details & Custom Fields
        </h4>
        <div className="row bg-white custom-border-radius-sm custom-shadow mx-1">
          <ShipCusCustomerDropDowns
            formData={formData}
            setFormData={setFormData}
            handleInputChange={handleInputChange}
          />
          <ShipCusCustomFields
            formData={formData}
            setFormData={setFormData}
            handleInputChange={handleInputChange}
          />
        </div>
      </div>
      <div className="d-flex justify-content-end mt-3 gap-1">
        <button
          onClick={() => {
            showModal(false);
          }}
          className="btn btn-secondary"
        >
          Close
        </button>

        <button onClick={handleSearch} className="btn btn-success">
          Search
        </button>
      </div>
    </div>
  );
}
